import GalleryManager from "./GalleryManager";
import CaseStudyManager from "./CaseStudyManager";
import BeforeAfterManager from "./BeforeAfterManager";

export default function ContentManager() {
  return (
    <div className="mx-auto max-w-7xl space-y-4 p-4 md:p-6" data-testid="content-manager">
      <div>
        <h1 className="font-display text-3xl font-bold uppercase text-white">Website content</h1>
        <p className="text-sm text-slate-400">Photos and case studies you add here appear on the public Projects page and project sections straight away.</p>
      </div>
      <CaseStudyManager />
      <BeforeAfterManager />
      <GalleryManager />
    </div>
  );
}
